import type { AnchorHTMLAttributes, MouseEvent, ReactNode, Ref } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { usePageTransition } from '@/components/generals/page-transition'

interface FadeLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    href: string
    ref?: Ref<HTMLAnchorElement>
    prefetch?: boolean
    scroll?: boolean
    children?: ReactNode
}

const pathOf = (href: string): string => href.split('#')[0].split('?')[0] || '/'

/** Internal link that closes the page to black before navigating. */
export const FadeLink = ({ href, onClick, target, children, ...rest }: FadeLinkProps): ReactNode => {
    const router = useRouter()
    const { navigate } = usePageTransition()

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event)

        if (event.defaultPrevented) return
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return
        if (target && target !== '_self') return
        if (href.includes('#') && pathOf(href) === pathOf(router.asPath)) return

        event.preventDefault()
        navigate(href)
    }

    return (
        <Link href={href} target={target} onClick={handleClick} {...rest}>
            {children}
        </Link>
    )
}
